import { ptBR } from '@/i18n/pt-BR';
import type { MemberRecord } from '@/lib/escritorios';
import { Button } from '@/components/ui';

/** E164.F2 (ADR-0113): a marca do responsável técnico, só sobre quem assina (E175.F1). */
export function MarcaDoResponsavel({ member }: { member: MemberRecord }) {
  if (member.responsavel_tecnico !== true) return null;
  return (
    <span data-testid="member-row-responsavel">
      {' · '}
      {ptBR.members.responsavelBadge}
    </span>
  );
}

export function BotaoDoResponsavel({
  member,
  visivel,
  busy,
  onSetResponsavel,
}: {
  member: MemberRecord;
  visivel: boolean;
  busy: boolean;
  onSetResponsavel?(member: MemberRecord, valor: boolean): void;
}) {
  if (!visivel || onSetResponsavel === undefined) return null;
  const marcado = member.responsavel_tecnico === true;
  return (
    <Button
      variant="secondary"
      type="button"
      title={ptBR.members.responsavelHint}
      onClick={() => onSetResponsavel(member, !marcado)}
      disabled={busy}
      data-testid={`member-row-responsavel-toggle-${member.id}`}
    >
      {marcado ? ptBR.members.revokeResponsavelCta : ptBR.members.grantResponsavelCta}
    </Button>
  );
}
